import { isNil, omitBy } from 'lodash';
import { memo, PropsWithChildren, useMemo } from 'react';
import useStyles, {
  StyledSystemStyle,
  StyledSystemStyles,
} from 'utils/useStyledSystem';

interface Style {
  padding?: StyledSystemStyle;
  paddingTop?: StyledSystemStyle;
  paddingRight?: StyledSystemStyle;
  paddingBottom?: StyledSystemStyle;
  paddingLeft?: StyledSystemStyle;
  margin?: StyledSystemStyle;
  marginTop?: StyledSystemStyle;
  marginRight?: StyledSystemStyle;
  marginBottom?: StyledSystemStyle;
  marginLeft?: StyledSystemStyle;
  width?: StyledSystemStyle;
  minWidth?: StyledSystemStyle;
  maxWidth?: StyledSystemStyle;
  height?: StyledSystemStyle;
  minHeight?: StyledSystemStyle;
  maxHeight?: StyledSystemStyle;
}

export interface SpacerProps extends Style {
  paddingVertical?: StyledSystemStyle;
  paddingHorizontal?: StyledSystemStyle;
  marginVertical?: StyledSystemStyle;
  marginHorizontal?: StyledSystemStyle;
  className?: string;
}

export default memo(function Spacer({
  children,
  className,
  ...stylesProps
}: PropsWithChildren<SpacerProps>) {
  const style = useMemo(() => {
    const {
      paddingHorizontal,
      paddingVertical,
      marginHorizontal,
      marginVertical,
      padding,
      margin,
      paddingLeft,
      paddingBottom,
      paddingRight,
      paddingTop,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      width,
      minWidth,
      maxWidth,
      height,
      minHeight,
      maxHeight,
    } = stylesProps;

    const style: Style = omitBy(
      {
        padding,
        paddingLeft: paddingLeft ?? paddingHorizontal,
        paddingRight: paddingRight ?? paddingHorizontal,
        paddingTop: paddingTop ?? paddingVertical,
        paddingBottom: paddingBottom ?? paddingVertical,
        margin,
        marginLeft: marginLeft ?? marginHorizontal,
        marginRight: marginRight ?? marginHorizontal,
        marginTop: marginTop ?? marginVertical,
        marginBottom: marginBottom ?? marginVertical,
        width,
        minWidth,
        maxWidth,
        height,
        minHeight,
        maxHeight,
      },
      isNil,
    );

    return style;
  }, [stylesProps]);

  const styles = useStyles(style as StyledSystemStyles);

  return (
    <div style={styles} className={className}>
      {children}
    </div>
  );
});
